import { enrich } from '@i18n/localizeHelper'
import { housingFormTabs } from './constants'
import type { HousingFormFeatures } from '@schema/featureToggle'

type PageTabTitles = Record<HousingFormFeatures, string>

export const getHousingFormPageTitle = (
  tab: HousingFormFeatures,
  entityName: string,
  pageTabTitles: PageTabTitles,
): string => {
  if (tab === housingFormTabs.overview) {
    return entityName
  }
  const template = pageTabTitles[tab]
  if (!template.includes('{0}')) {
    return template
  }
  return enrich(template, entityName)
}
